export default "__VITE_ASSET__11092df9__"